/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { TECH_BUFFER, EXTERNAL_INTEGRATION_BUFFER, CLARITY_BUFFER,BASE_EFFORT, OVERALL_BUFFER } from '../resources/endPoint';

export const saveTechBuffer = (data) => {
  return {
    url: TECH_BUFFER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const saveExternalIntegrationBuffer = (data) => {
  return {
    url: EXTERNAL_INTEGRATION_BUFFER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const saveClarityBuffer = (data) => {
  return {
    url: CLARITY_BUFFER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};


export const saveFrontEndBuffer = (data) => {
  return {
    url: BASE_EFFORT,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const getTechBuffer = (type, active) => {
  return {
    url: `${TECH_BUFFER}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getClarityBuffer = (type, active) => {
  return {
    url: `${CLARITY_BUFFER}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getExternalIntegrationBuffer = (type, active) => {
  return {
    url: `${EXTERNAL_INTEGRATION_BUFFER}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getFrontEndBuffer = (type, active) => {
  return {
    url: `${BASE_EFFORT}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const updateTechBuffer = (data) => {
  return {
    url: TECH_BUFFER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const updateExternalIntegrationBuffer = (data) => {
  return {
    url: EXTERNAL_INTEGRATION_BUFFER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const updateClarityBuffer = (data) => {
  return {
    url: CLARITY_BUFFER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const updateFrontEndBuffer = (data) => {
  return {
    url: BASE_EFFORT,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const deleteBuffer = (id) => {
  return {
    url: `${BASE_EFFORT}?id=${id}`,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getOverallBuffer = (type, active) => {
  return {
    url: `${OVERALL_BUFFER}?type=${type}&is_active=${active}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
